export type AssetsTableColumnId =
  | 'name'
  | 'category'
  | 'tags'
  | 'risk.count'
  | 'legacyDeviceIds'
  | 'sources'
  | 'risk.score'
  | 'importance'
  | 'risk.lastSuccessfulScanned'
  | 'lastSeenTime'
  | 'ipAddress'
  | 'mac'
  | 'os'
  | 'hostname'
  | 'netbios'
  | 'osType'
  | 'actions';

export const ASSET_COLUMNS_DEFS = {
  NAME: 'name',
  CATEGORY: 'category',
  TAGS: 'tags',
  RISK_COUNT: 'risk.count',
  LEGACY_DEVICE_IDS: 'legacyDeviceIds',
  SOURCES: 'sources',
  RISK_SCORE: 'risk.score',
  IMPORTANCE: 'importance',
  LAST_SUCCESSFUL_SCANNED: 'risk.lastSuccessfulScanned',
  LAST_SEEN_TIME: 'lastSeenTime',
  ACTIONS: 'actions',
  IP_ADDRESS: 'ipAddress',
  MAC: 'mac',
  OPERATING_SYSTEM: 'os',
  HOSTNAME: 'hostname',
  NETBIOS: 'netbios',
  OS_TYPE: 'osType',
} as const satisfies Record<string, AssetsTableColumnId>;

// Max limit for the number of filters that can be applied
export const MAX_FILTERS_LIMIT = 10;
// Max limit for the number of values that can be selected in a filter
export const MAX_FILTER_VALUES_LIMIT = 5;
// Session storage key for assets table DataGrid state
// This is used to persist the DataGrid state across page reloads
export const ASSETS_DATA_GRID_STATE_KEY = 'assetsDataGridState';
